import { FEATURE_FLAGS } from '@aibees/elephant/constants';
import { FeatureFlags, SearchMatchType } from '@aibees/elephant/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { isFeatureEnabled } from '@aibees/shared/feature-flags';
import { capitalize } from '@aibees/shared/utils';
import {
  ClassificationGroups,
  ClassificationType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';

export default function skillsFilterConfig(): SearchFilterBase {
  return {
    name: 'Skills',
    comingSoon: !isFeatureEnabled(
      FEATURE_FLAGS,
      FeatureFlags.FILTER_PEOPLE_SKILLS
    ),
    disabled: !isFeatureEnabled(
      FEATURE_FLAGS,
      FeatureFlags.FILTER_PEOPLE_SKILLS
    ),
    icon: 'skills',
    index: 26,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.CONTACT_DATA],
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Skills',
        },
      },
    },
    layer: 3,
    pinned: true,
    sections: { main: 2, more: 1 },
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        field: 'include_skills',
        key: 'include_skills',
        exactMatch: {
          enabled: true,
          default: SearchMatchType.SMART,
        },
        metadata: {
          color: 'primary',
          preset: 'skills',
          placeholder: 'Include Skills ( OR ) Search',
          autocomplete: {
            checkboxPosition: 'left',
            multiple: true,
            recent: false,
            transformSearchValue: (v: string) => v.toLowerCase(),
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.PERSON}&key=${ClassificationType.SKILL}`,
          },
        ],
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 1,
        layer: 4,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.SMART,
        },
        key: 'exclude_skills',
        field: 'exclude_skills',
        metadata: {
          color: 'error',
          icon: 'block',
          preset: 'skills',
          placeholder: 'Exclude Skills ( OR ) Search',
          autocomplete: {
            checkboxPosition: 'left',
            multiple: true,
            recent: false,
            transformSearchValue: (v: string) => v.toLowerCase(),
            allowCustomValuesByEnter: true,
          },
        },
        searchKey: 'value',
        utils: {
          tags: { labelFormatter: capitalize },
        },
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.PERSON}&key=${ClassificationType.SKILL}`,
          },
        ],
      },
      {
        name: 'Include (AND)',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 2,
        layer: 4,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.SMART,
        },
        field: 'all_of_skills',
        key: 'all_of_skills',
        metadata: {
          color: 'warning',
          icon: 'add-task',
          preset: 'skills',
          placeholder: 'Include Skills ( AND ) Search',
          autocomplete: {
            checkboxPosition: 'left',
            multiple: true,
            recent: false,
            transformSearchValue: (v: string) => v.toLowerCase(),
            allowCustomValuesByEnter: true,
          },
        },
        searchKey: 'value',
        utils: {
          tags: { labelFormatter: capitalize },
        },
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.PERSON}&key=${ClassificationType.SKILL}`,
          },
        ],
      },
    ],
  };
}
